<template>
	<div class="animated fadeIn invoices--invoices-list">
		<div class="d-flex justify-content-start align-items-end mb-2" v-if="isAccountPage">
			<b-form-group label="Status" class="mr-2">
				<b-form-select v-model="filterObj.statusId" @change="onSearch">
					<option :value="null">All</option>
					<option v-for="option in sortSelect(statusOptions)" :key="option.name" :value="option.id">
						{{option.name}}</option>
				</b-form-select>
			</b-form-group>
				<b-form-group label="Invoice #" class="mr-2">
				<b-form-input v-model="filterObj.invoiceNumber" @input="onSearch" size="sm" />
			</b-form-group>
			<b-form-group label="Sales Order #" class="mr-2">
				<b-form-input v-model="filterObj.soNumber" @input="onSearch" size="sm" />
			</b-form-group>
			<b-form-group label="Past Due" class="mr-2">
				<b-form-checkbox v-model="filterObj.pastDue" @input="onSearch" value="true" unchecked-value="" />
			</b-form-group>
			<b-form-group label="Company" class="mr-2">
				<b-form-input v-model="filterObj.companyName"  @input="onSearch" size="sm" />
			</b-form-group>
			<b-form-group label="Sales Rep" class="mr-2">
				<b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
					<option :value="null">All</option>
					<option
						v-for="(selectRep, indexRep) in sortSelect(salesReps)"
						:key="indexRep"
						:value="selectRep.id"
					>{{ selectRep.name }}</option>
				</b-form-select>
			</b-form-group>
			<date-range-picker ref="dateRangePicker" :handleSearch="onSearch"></date-range-picker>
			<b-button class="mr-2" size="sm" @click="onClear">Clear</b-button>
		</div>
    <!--isSortable-->
		<grid-component
			isResizable
			isReorderable
      :canEdit="checkClaim(CAN_EDIT_INVOICES)"
      :canDelete="checkClaim(CAN_DELETE_INVOICES)"
			:gridId="gridId"
			:itemData="itemData"
			:fields="fields"
			:onEdit="pushToDetails"
			:sortBy="pageInfo.sortBy"
			:sortOrder="pageInfo.sortOrder"
			:sortMethod="sortGrid"
			@rowclick="onRowClick"
			:navigationField="'invoiceId'"
			/>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { debounce, unionBy } from 'lodash';
import { SORT_ORDER, GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';

import gridFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;
import DateRangePicker from '@/shared/components/DateRangePicker';
export default {
  components: {
    GridComponent,
    DateRangePicker,
  },
  props: {
    companyId: {
      type: [Number, String],
      default: 0,
    },
    partId: {
      type: [Number, String],
      default: 0,
    },
    gridId: {
      type: String,
      default: GRID_ID.INVOICES_LINES,
    },
    partNumber: {
      type: String,
      default: null,
    },
    quoteLineId: {
      type: [Number, String],
      default: 0,
    },
    isInvoiceTab: {
      type: Boolean,
      default: false,
    },
    isPartTab: {
      type: Boolean,
      default: false,
    },
    isAccountPage: {
      type: Boolean,
      default: false,
    },
    salesOrderLineId: {
      type: [Number, String],
      default: 0,
    },
    invoiceLineId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      fields: gridFields,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      statusOptions:[
        { id: null, name: '' },
        { id: 138, name: 'New' },
        { id: 139, name: 'Sent' },
        { id: 140, name: 'Paid' },
      ],
    };
  },
  computed: {
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('invoices', [
      'invoices',
      'pageInfo',
      'selectedItemId',
      'invoicesFiltered',
      'filters',
      'dateRange',
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      const items = (this.isInvoiceTab || this.isPartTab) ? this.invoicesFiltered : this.invoices;
      if (items.length) {
        return items.map((invoice) => ({ ...invoice, selected: invoice.id === this.selectedRowItemId }));
      }
      return null;
    },
    filterObj() {
      return this.filters['sharedInvoiceLine'] || {}
    }
  },
  methods: {
    ...mapMutations('invoices', {invoiceSetItem:'setItem'}),
    ...mapActions('invoices', ['getAll', 'sortGrid', 'getPage','clearFilters', 'search', 'select', 'getInvoicesByPart', 'getInvoicesBySalesOrderLine', 'getInvoiceLineAsList']),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('salesReps', ['getSalesReps']),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      // const { id, detailsVisible } = row.dataItem;
      // this.select({ id, isChecked: !detailsVisible });
    },
    pushToDetails(row) {
      this.$router.push({
        name: 'invoices.edit',
        params: { id: row.invoiceId },
      });
    },
    onSearch: debounce(function (data = false) {
      if(this.isAccountPage) {
        if(typeof data === 'object') { Object.assign(this.filterObj,data) }
        this.filterObj.hasBalance=true;
      }
      this.search({ 'filters': this.filterObj, page: 'sharedInvoiceLine' });
    }, SEARCH_DEBOUNCE_TIME),
    onClear() {
      this.clearFilters()
      Object.keys(this.filterObj).forEach(filterName => {
        this.filterObj[filterName] = null;
      });
      this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
      this.filterObj.hasBalance=true;
      this.search({ 'filters': this.filterObj, page: 'sharedInvoiceLine' });
    },
  },
  watch: {
    invoices() {
      //This function sets the first row as the selected row
      if (this.invoices.length > 0 && this.selectedRowItemId === 0) {
        this.selectedRowItemId = this.invoices[0].id;
        const { id, detailsVisible } = this.invoices[0];
        this.select({ id, isChecked: !detailsVisible });
      }
    },
    async partId() {
      if (this.isInvoiceTab || this.isPartTab) {
        /*this.setInvoicesFiltered([]);*/
        this.invoiceSetItem({ resource: 'invoicesFiltered', payload: [] });
        await this.getInvoicesByPart(this.partId);
      }
    },
    async salesOrderLineId() {
      if (this.isInvoiceTab) {
        /*this.setInvoicesFiltered([])*/
        this.invoiceSetItem({ resource: 'invoicesFiltered', payload: [] });
        await this.getInvoicesBySalesOrderLine(this.salesOrderLineId);
      }
    },
    async invoiceLineId() {
      if (this.isInvoiceTab) {
        /*this.setInvoicesFiltered([]);*/
        this.invoiceSetItem({ resource: 'invoicesFiltered', payload: [] });
        await this.getInvoiceLineAsList(this.invoiceLineId);
      }
    }
  },
  async mounted() {
    if (!this.isInvoiceTab && !this.isPartTab) {
      /*this.getAll({
        ...this.gridSettings.sort,
        pageSize: this.gridSettings.pageSize || this.take,
      });*/

      this.invoiceSetItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      await this.getAll({});
    } else {
      // Removed pagination if by tab, go with Watch quoteLineId (This is temporary...)
      this.pageable = {};
    }
    if(this.isAccountPage) {
      this.invoiceSetItem({ resource:'filterPage', payload: 'sharedInvoiceLine' });
      this.getSalesReps(); this.filterObj.hasBalance=true;
    }
  },
  beforeDestroy() {
    /*this.select({ id: null, isChecked: false });*/
  },
};
</script>

<style lang="scss">
	@import '@/assets/scss/_colors.scss';

	#invoices-header-nav {
		width: 100%;
		z-index: 1000;
		position: fixed;
		border-bottom: 1px solid rgb(200, 206, 211);
		background: #fff;
	}

	#invoices-header-nav-txt {
		background-color: #fff;
		padding: 8px;
		font-size: 20px;
		margin: 0px;
	}


	.invoices {
		&--invoices-list {
			.tools>* {
				margin: 0 0 0 3px;
			}

			.b-pagination {
				justify-content: center;
			}

			.create-ultra-rfp {
				margin-top: 0.5em;
				margin-bottom: 1em;
			}

			table td {
				cursor: pointer;
			}

			.buttons-panel {
				text-align: right;
				margin-right: 30px;
				margin-top: 7px;

				.btn {
					margin-left: 5px;
				}

			}

			.clear-filter-button-container {
				margin-top: 12px;
				text-align: right;
			}
		}

		&--grid-header {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	.highlight {
		background: $rowSelection !important;
	}

	.b-pagination {
		justify-content: center;
	}

	.tools>* {
		margin: 0 0 0 3px;
	}

	#KendoGrid .k-virtual-scrollable-wrap table {
		min-width: 800px;
	}
</style>
